import React, {Component} from 'react'
import { connect } from 'react-redux'

import {setClass} from 'store/actions/playerAction'

class OverlayClasses extends Component{


  constructor(props){
    super(props)
    this.state = {
      classType:1,
      duration:2
    }
  }
  selectClass(classType){
    this.setState({
      classType:classType
    })
  }

  selectTime(duration){
    this.setState({
      duration:duration
    })
  }

  getClass(){
    const {classData} = this.props
    const {classType,duration} = this.state
    let classID
    switch(classType){
      case 1:
        classID = duration === 1 ? 5 : 6
        return classData.find(elem => elem.id === classID)
      case 2:
        classID = duration === 1 ? 7 : 8
        return classData.find(elem => elem.id === classID)
      case 3:
        classID = duration === 1 ? 9 : 10
        return classData.find(elem => elem.id === classID)
    }
  }

  startClass(){
    this.props.dispatch(
      setClass(
        this.getClass(),
        this.state
      )
    )
  }

  render(){
    const {classType, duration} = this.state
    return (
      <div className="overlay-classes">
        <div className="classes-wrapper">
          <h3>flow:</h3>
          <div className="class-button-wrapper">
            <div className={`class-button ${classType === 1 ? 'active' : ''}`} onClick={() => this.selectClass(1)}>Hotpod <br/>Flow</div>
          </div>
          <div className="class-button-wrapper">
            <div className={`class-button ${classType === 2 ? 'active' : ''}`} onClick={() => this.selectClass(2)}>nurturing <br/>Flow</div>
            <div className={`class-button ${classType === 3 ? 'active' : ''}`} onClick={() => this.selectClass(3)}>dynamic <br/>Flow</div>
          </div>
        </div>
        <div className="classes-wrapper">
          <h3>duration:</h3>
          <div className="class-button-wrapper">
            <div className={`class-button ${duration === 2 ? 'active' : ''}`} onClick={() => this.selectTime(2)}>45 minutes</div>
            <div className={`class-button ${duration === 1 ? 'active' : ''}`} onClick={() => this.selectTime(1)}>1 hour</div>
          </div>
        </div>
        <div className="start-class" onClick={() => this.startClass()}>
          <img src="img/play-button.svg"/>
          <span>Play</span>
        </div>
      </div>
    )
  }
}
function mapStateToProps(store){
  return {
    classData:store.player.classes
  }
}

export default connect(mapStateToProps)(OverlayClasses)


// WEBPACK FOOTER //
// ./src/components/overlay/OverlayClasses.js